import type { ApolloClient } from '@apollo/client';

import {
  createEmbedSessionGateway,
  type EmbedSessionGateway,
  type RawEmbedSession,
} from '@/shared-utilities';
import {
  ADD_HYPERBEAM_SESSION,
  REMOVE_HYPERBEAM_SESSION,
} from '@/survey-graphql';

export type HyperbeamSessionGateway = EmbedSessionGateway;

export function createHyperbeamSessionGateway(
  client: ApolloClient
): HyperbeamSessionGateway {
  return createEmbedSessionGateway({
    create: ({ startUrl, width, height }) =>
      client.mutate({
        mutation: ADD_HYPERBEAM_SESSION,
        variables: {
          input: {
            startUrl,
            ...(width !== undefined ? { width } : {}),
            ...(height !== undefined ? { height } : {}),
          },
        },
        errorPolicy: 'all',
      }),
    remove: (sessionId) =>
      client.mutate({
        mutation: REMOVE_HYPERBEAM_SESSION,
        variables: { input: { sessionId } },
        errorPolicy: 'all',
      }),
    select: (data): RawEmbedSession | null | undefined =>
      data?.addHyperbeamSession,
    toErrorMessage: (error) => error?.message ?? '',
    noDataMessage: 'addHyperbeamSession returned no data',
    removeFailureLabel: 'removeHyperbeamSession failed',
  });
}
